export class QueryBuilderContainerController {

  constructor(
    $scope,
    $element,
  ) {
    this.$scope = $scope;
    this.group = null;
    this.canShow = false;
    this.$element = $element;

    $scope.$on('init', () => {
      this.canShow = true;
    });

    $scope.$watch('$ctrl.group', () => {
      this.updateField();
    }, true);
  }

  updateField() {
    this.jsonGroup = angular.toJson(this.group);
    const field = this.$element.closest('.query-access-container').find(`textarea[name="${this.fieldName}"]`);
    field.val(this.jsonGroup);
  }

  $onInit() {
    if (this.jsonGroup) {
      this.group = angular.fromJson(this.jsonGroup);
    }
  }

}

export const QueryBuilderContainerComponent = {
  bindings: {
    fieldName: '<',
    jsonGroup: '<',
  },
  template: require('./query-builder-container.component.html'),
  controller: QueryBuilderContainerController,
  controllerAs: '$ctrl',
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/query-builder-container.component.js